import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Application } from './types'

// The fields the sidebar, the route guard and the action buttons read; the API computes them for
// the signed-in user (see AGENTS.md "Roles and permissions"), so the web decides nothing itself
export const VIEWER_FIELDS = `
  viewerPermissions { resource actions }
  viewerCanManageUsers
`

export const APPS_QUERY: TypedDocumentNode<
  { applications: Application[] },
  { clientId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Applications($clientId: ID!, $search: String, $limit: Int, $offset: Int) {
    applications(clientId: $clientId, search: $search, limit: $limit, offset: $offset) {
      id client_id name onesignal_id accesses observations min_version latest_version store_url_android store_url_ios api_base_url image_base_url created_at updated_at
      ${VIEWER_FIELDS}
    }
  }
`

export const ALL_APPS_QUERY: TypedDocumentNode<
  { applications: Application[] },
  Record<string, never>
> = gql`
  query AllApplications {
    applications {
      id client_id name accesses
      ${VIEWER_FIELDS}
    }
  }
`

export const APP_QUERY: TypedDocumentNode<{ application: Application | null }, { id: string }> =
  gql`
  query Application($id: ID!) {
    application(id: $id) {
      id client_id name onesignal_id accesses observations min_version latest_version store_url_android store_url_ios api_base_url image_base_url created_at updated_at
      ${VIEWER_FIELDS}
    }
  }
`
